// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nr-c";
export var backButton = "_nr-4";
export var backIcon = "_nr-5";
export var chevronShortcut = "_nr-6";
export var container = "_nr-1";
export var editor = "_nr-8";
export var editorWrapper = "_nr-7";
export var prefix = "_nr-2";
export var searchIcon = "_nr-3";
export var suffix = "_nr-9";
export var suffixContent = "_nr-a";
export var suffixText = "_nr-b";
export var wrapper = "_nr-0";